import { useTranslation } from "react-i18next";
import { professionalExperience } from "../data/professionalExperience";

export default function ProfessionalExperience() {
  const { t, i18n } = useTranslation('translation', { useSuspense: false });
  
  const groupedExperiences = professionalExperience[i18n.language].reduce((acc, exp) => {
    if (!acc[exp.company]) {
      acc[exp.company] = [];
    }
    acc[exp.company].push(exp);
    return acc;
  }, {});

  return (
    <section className="section">
      <h2>{t('title.experience')}</h2>
      {Object.entries(groupedExperiences).map(([company, experiences]) => (
        <div key={company}>
          <h3>{company}</h3>
          {experiences.map((exp, index) => (
            <div key={index}>
              <p><b>{exp.role}</b></p>
              <p>{exp.period}</p>
              <ul>
                {exp.description.map((desc, descIndex) => (
                  <li key={descIndex}>{desc}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      ))}
    </section>
  );
}
